module.exports = __webpack_public_path__ + "static/media/mvltaxi_driver_terms_ko.742b1fd9.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/mvltaxi_driver_terms_ko.md
// module id = 62
// module chunks = 0